// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1___8b4a2995afe7ead7d83","cls2":"ImpactHubModal-cls2___1f13e613ece06bff1da ImpactHubModal-cls1___8b4a2995afe7ead7d83"};